import React from 'react'
import {Icon} from '@chakra-ui/react'

const MapIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M16.08 3.29L8.02 5.43L0 3V18.01L7.98 21.43L15.98 18.43L24 21.87V6.69L16.08 3.29ZM7 18.83L2 16.69V5.7L7 7.22V18.84V18.83ZM15 16.66L9 18.91V7.24L15 5.64V16.65V16.66ZM22 18.83L17 16.69V5.87L22 8.01V18.83Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default MapIcon
